import { useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Alert, Box, CircularProgress } from '@mui/material';
import axios from 'axios';
import { apiPathUrl } from '../../utils/config';
import LegalPolicyDocument from './LegalPolicyDocument';
import { getLegalPolicyConfig } from './legalPolicyConfig';

const publicApi = axios.create({
  baseURL: apiPathUrl,
  headers: { Accept: 'application/json' },
});

const LegalPolicyPublicPage = ({ policyType }) => {
  const config = useMemo(() => getLegalPolicyConfig(policyType), [policyType]);
  const { provider } = useParams();
  const [policy, setPolicy] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    setLoading(true);
    setError('');
    publicApi.get(config.endpoint(provider))
      .then((response) => setPolicy(response?.data?.data || null))
      .catch(() => setError(`${config.title} is not currently available.`))
      .finally(() => setLoading(false));
  }, [config, provider]);

  if (loading) return <Box sx={{ minHeight: '100vh', display: 'grid', placeItems: 'center', bgcolor: '#f5f8fc' }}><CircularProgress /></Box>;
  if (error || !policy) return <Box sx={{ minHeight: '100vh', display: 'grid', placeItems: 'center', bgcolor: '#f5f8fc', p: 2 }}><Alert severity="info">{error || 'This policy is not currently available.'}</Alert></Box>;

  return <LegalPolicyDocument policy={policy} />;
};

export default LegalPolicyPublicPage;
